import styles from '@/styles/Footer.module.css'
import dynamic from 'next/dynamic'
import { useTranslation } from 'react-i18next'

// const Map = dynamic(() => import('@/app/map/Map'))
const FieldsetComponent = dynamic(
  () => import('@/components/FieldsetComponent '),
)
const SwishComponent = dynamic(() => import('@/components/SwishComponent '))
const MapLeaflet = dynamic(() => import('./MapLeaflet'), {
  ssr: false,
})

const Footer = () => {
  const date = new Date()
  const year = date.getFullYear()
  const { t, i18n } = useTranslation()

  return (
    <footer className={styles.footer}>
      <div className={styles.wrapper}>
        <h2 className={styles.title}>{t('Find Our Restaurant')}</h2>

        <div className={styles.grid}>
          <div className={styles.mapCard}>
            <MapLeaflet />
          </div>

          <div className={styles.sideColumn}>
            <FieldsetComponent />
            <SwishComponent />
          </div>
        </div>

        <p className={styles.copy}>© {year} La Bambi</p>
      </div>
    </footer>
  )
}
export default Footer
